import { CascadeLogTable } from "components/Tables/CascadeLogTable/CascadeLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/")({
    component: PingtreeLogPage,
    staticData: {
        permissions: [PermissionEnum.CascadeLogView],
        showInSideMenu: false,
        label: "pages.log.pingtree.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.pingtree.title"),
        };
    },
});

function PingtreeLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <CascadeLogTable />
        </TenantPage>
    );
}
